export function prepareObjectModel(model) {
  let containersVolumeSum = 0
  // if backend don't send containers count
  // use daily_norm as containers_count
  if (!model.hasOwnProperty('containers_count') && model.daily_norm) {
    model.containers_count = Math.round(model.daily_norm)
  }
  // if you have volume_count
  if (model.volume_count) {
    containersVolumeSum = (model.volume_count * 1).toFixed(3)
  } else if (model.containers_count) {
    containersVolumeSum = (model.containers_count * 0.75).toFixed(3)
  }
  if (isNaN(containersVolumeSum)) {
    containersVolumeSum = 0
  }
  model = {
    ...model,
    containersVolumeSum,
  }
  return model
}
